var patt = /&(#?)([a-z0-9]+);/ig
  , map

function handler(ent, isNum, content) {
  if (isNum) {
    var num
    if (content.charAt(0) === 'x') {
      num = parseInt('0' + content, 16)
    } else {
      num = parseInt(content, 10)
    }
    return String.fromCharCode(num)
  } else {
    return map[content] || ent
  }
}

export default function (text, aMap) {
  map = aMap
  return text.replace(patt, handler)
}


// WEBPACK FOOTER //
// ./src/common/components/process-editor/modules/dinnerSvg/tokenizer/deentityify.js